import axios from "axios";

// Prefer same-origin `/api` so the app works from any host that the Emergent
// ingress serves (including custom domains like descon.group). Fallback to the
// configured REACT_APP_BACKEND_URL only when the app isn't served from the same
// host as the API (e.g. local dev).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API =
  typeof window !== "undefined" && window.location && window.location.origin
    ? `${window.location.origin}/api`
    : `${BACKEND_URL}/api`;

const TOKEN_KEY = "descon_access_token";

// Guard: uncaught axios rejections (e.g. background loads hitting 403 for a
// restricted role) must not surface the dev error overlay / crash the page.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason && (event.reason.isAxiosError || event.reason.response)) {
      console.warn("Unhandled API error:", event.reason?.response?.status, event.reason?.config?.url);
      event.preventDefault();
    }
  });
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export function formatCurrency(n, currency = "USD") {
  if (n == null) return "—";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(n);
  } catch {
    return `${currency} ${Number(n).toLocaleString()}`;
  }
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
